export const Header = (props) => {
  return (
    <header id='features'>
      <div className='intro'>
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-8 col-md-offset-2 intro-text'>
                <h1>
                  {props.data ? props.data.title : 'Loading'}
                  <span></span>
                </h1>
                <h3 style={{color: '#fff', fontWeight: 'bold'}}>{props.data ? props.data.paragraph : 'Loading'}</h3>
                <a
                  href='#contact'
                  className='btn btn-custom btn-lg page-scroll'
                  style={{marginTop: '20px'}}
                >
                  Fale conosco
                </a>{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
